<template>
  <div>
    <question-template
      name="isIncomeOver"
      :showTutorials="showTutorials"
      description="(ประมาณ 150,000 บาท/เดือน หรือ 5,000 บาท/วัน)"
    />
    <tutorial />
  </div>
</template>

<script>
import Tutorial from "./Tutorial.vue";
export default {
  name: "IncomeRate",
  components: {
    tutorial: Tutorial,
  },
  computed: {
    showTutorials() {
      return this.$store.getters["app/getApp"].showIncomeRateTutorial;
    },
  },
};
</script>

<style scoped></style>
